/**
 * Guarda de rutas protegidas.
 *
 * Mientras `/auth/me` hidrata, muestra un estado de carga. Si el resultado es
 * "no autenticado" (p. ej. `/auth/me` respondió 401), redirige a `/login`
 * recordando el destino para volver tras iniciar sesión. Si hay sesión, deja
 * pasar a las rutas hijas (`<Outlet />`).
 *
 * Se usa como ruta envolvente de React Router:
 *
 *     <Route element={<RequireAuth />}>
 *       <Route path="/" element={<Dashboard />} />
 *     </Route>
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "./useAuth";

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-slate-50 text-slate-500"
        role="status"
        aria-live="polite"
      >
        Cargando sesión…
      </div>
    );
  }

  if (status === "unauthenticated") {
    // `replace` para no apilar la ruta protegida en el historial; `state.from`
    // permite volver al destino original tras un login exitoso.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
